module.exports = __webpack_public_path__ + "static/media/banner-grupos.5bb4c2dc.png";